export default [
  // 车辆解绑
  {
    path: '/myCar-unbinding',
    component: () => import('@/views/myCar/unbinding/Index.vue'),
    name: 'myCar-unbinding',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-light-gray',
    },
  },
  // 车辆解绑结果
  {
    path: '/myCar-unbinding-result',
    component: () => import('@/views/myCar/unbinding/Result.vue'),
    name: 'myCar-unbinding-result',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-light-gray',
    },
  },
  // 车联网-智能网联功能介绍
  {
    path: '/myCar-iov-tboxIntro',
    component: () => import('@/views/myCar/iov/TboxIntro.vue'),
    name: 'myCar-iov-tboxIntro',
    meta: {
      translateKey: 'cfmoto.serviceIntroduction',
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 车联网-智能网联功能介绍
  {
    path: '/myCar-iov-tboxInstall',
    component: () => import('@/views/myCar/iov/TboxInstall.vue'),
    name: 'myCar-iov-tboxInstall',
    meta: {
      translateKey: 'cfmoto.serviceIntroduction',
      appName: 'TBoxDeviceInstall', // 实际要跳到APP页面
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 车联网-智能网联功能介绍
  // {
  //   path: '/myCar-iov-tboxIntro1',
  //   component: () => import('@/views/myCar/iov/TboxIntro1.vue'),
  //   name: 'myCar-iov-tboxIntro1',
  //   meta: {
  //     translateKey: 'cfmoto.serviceIntroduction',
  //     auth: 0,
  //     visibleShare: true,
  //     backgroundClass: 'bg-white',
  //   },
  // },
  // 车联网-绑定tbox设备
  {
    path: '/myCar-iov-tboxBind',
    component: () => import('@/views/myCar/iov/TboxBind.vue'),
    name: 'myCar-iov-tboxBind',
    meta: {
      translateKey: 'cfmoto.bindDevice',
      appName: 'BindNoTBoxDevice', // 实际要跳到APP页面
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 车联网-tbox设备安装说明书
  {
    path: '/myCar-iov-installManual',
    component: () => import('@/views/myCar/iov/InstallManual.vue'),
    name: 'myCar-iov-installManual',
    meta: {
      translateKey: 'ACCESSORY SETUP INSTRUCTION',
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 模式设置-编辑
  {
    path: '/myCar-modeSetting-index',
    component: () => import('@/views/myCar/modeSetting/Index.vue'),
    name: 'myCar-modeSetting-index',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
  // 模式设置-登录
  {
    path: '/myCar-modeSetting-login',
    component: () => import('@/views/myCar/modeSetting/Login.vue'),
    name: 'myCar-modeSetting-login',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 仪表升级
  {
    path: '/myCar-ota-instrumentUpgrade-:deviceId',
    component: () => import('@/views/myCar/ota/InstrumentUpgrade.vue'),
    name: 'myCar-ota-instrumentUpgrade',
    meta: {
      translateKey: 'cfmoto.instrumentupgrade',
      auth: 1,
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
  // 升级助手
  {
    path: '/myCar-ota-upgradeHelper-:deviceId',
    component: () => import('@/views/myCar/ota/UpgradeHelper.vue'),
    name: 'myCar-ota-upgradeHelper',
    meta: {
      translateKey: 'cfmoto.upgradeAssistant',
      auth: 1,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
];
